import { useQuery } from "@tanstack/react-query";
import {
  inspecaoService,
  InspecaoPedidoTempoParams,
  InspecaoPedidoTempoResponse,
} from "../services/inspecaoService";

export const useInspecaoPedidoTempo = (
  params: InspecaoPedidoTempoParams | undefined
) => {
  return useQuery<InspecaoPedidoTempoResponse[]>({
    queryKey: ["inspecao-pedido-tempos", params],
    queryFn: () => inspecaoService.getPedidoTempos(params!),
    enabled: !!params && !!params.displayId,
  });
};
